import type { Cafe } from 'src/types/types';
import { Heading } from 'src/components/Heading/Heading';
import { CafeMeta } from 'src/components/CafeMeta/CafeMeta';

import styles from './styles.module.scss';

type CafeInfoProps = {
  cafe: Cafe;
};

export const CafeInfo = ({ cafe }: CafeInfoProps) => (
  <>
    <Heading level={1}>{cafe.name}</Heading>
    {cafe.tagline && <p className={styles.tagline}>{cafe.tagline}</p>}
    <CafeMeta
      address={cafe.address}
      hours={cafe.hours}
      phone={cafe.phone}
      email={cafe.email}
    />
    <div className={styles.divider} />
  </>
);
